import { render, staticRenderFns } from "./ManualDiscount.vue?vue&type=template&id=28be204a"
import script from "./ManualDiscount.vue?vue&type=script&lang=ts"
export * from "./ManualDiscount.vue?vue&type=script&lang=ts"
import style0 from "./ManualDiscount.vue?vue&type=style&index=0&id=28be204a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports